<template>
  <b-modal id="invoiceDataEditModal" size="xl" hide-footer>
    <b-row slot="modal-header">
      <b-col>
        <h6>{{$t('views.exsbinvoices.invoiceDataEditModal.header')}}</h6>
      </b-col>
    </b-row>
    <Update :openInModal="true" :editType="'data'" :idInvoice="idInvoice"></Update>
  </b-modal>
</template>

<script>
import Update from '../../Update'
export default {
  name: 'InvoiceDataEditModal',
  components: {
    Update
  },
  computed: {
    show () {
      return this.$store.state.modals.exsbinvoices.update.dataUpdateShow
    },
    close () {
      return this.$store.state.modals.exsbinvoices.update.dataUpdateClose
    },
    idInvoice () {
      return this.$store.state.modals.exsbinvoices.update.idInvoice
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'idInvoice': function (val) {
      this.openModal()
    },
    'close': function (val) {
      if (val === 1) {
        this.$store.state.modals.exsbinvoices.update.dataUpdateClose = 0
        this.closeModal()
      }
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.idInvoice > 0) {
        this.$store.state.modals.exsbinvoices.update.dataUpdateShow = 0
        this.$bvModal.show('invoiceDataEditModal')
      }
    },
    closeModal () {
      this.$bvModal.hide('invoiceDataEditModal')
    },
    resetData () {
      // null
    }
  }
}
</script>
